import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  margin: 0;

  ${({ theme }) => `${theme.breakpoints.xxl} {
      display: grid;
      grid-template-rows: 1fr;
      grid-template-columns: 55% 45%;
      align-items: stretch;
    }
  `}
`;

export const SlideShowWrapper = styled.section`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  width: auto;

  ${({ theme }) => `${theme.breakpoints.md} {
    width: 400px;
  }
`}
`;
export const SlideShowWrapperliveshows = styled.section`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  width: auto;

  ${({ theme }) => `${theme.breakpoints.md} {
    width: 100%;
  }
`}
`;

export const Label = styled.p`
  font-size: 0.75rem;
  margin-bottom: var(--space-50);
  order: 1;
`;

export const Content = styled.div`
  padding: var(--space-50) var(--space-100) var(--space-100);
  background-color: var(--colour-bg-alternative);
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  order: 2;
  > *:not(${Label}) {
    order: 2;
  }
  ${({ theme }) => `${theme.breakpoints.sm} {
    padding: var(--space-50) 0 0;
  }
`}
`;

export const Children = styled.div`
  margin-bottom: var(--space-100);
`;

export const Title = styled.h2`
  margin-bottom: var(--space-150);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-break: break-word;
  margin-bottom: 1rem;
`;

export const Eventtitle = styled.h3`
  margin-bottom: var(--space-150);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-break: break-word;
  margin-bottom: 1rem;
  font-size:1.22rem;
  overflow-wrap: anywhere;
`;

export const ImageWrapper = styled.div`
  overflow: hidden;
  position: relative;
  order: 1;
  margin: 0;
  padding: 0;
  
  ${Wrapper} & {
    ${({ theme }) => `${theme.breakpoints.xxl} {
      height: 100%;
      align-self: stretch;
      
      > div {
        height: 100%;
        width: 100%;
        padding-bottom: 0 !important;
      }
      
      img {
        height: 100% !important;
        width: 100%;
        object-fit: cover;
        position: static !important;
      }
    }`}
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: var(--space-100);
`;

export const ArrowIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  border: 2px solid currentColor;
  background-color: var(--colour-neutral-white);
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
  display: flex;
  flex-direction: column;
  height: 100%;
  color: inherit;
  
  &:hover {
    text-decoration: none;
  }
  
  &:hover h3 {
    text-decoration: underline;
  }
  
  &:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }
  
  ${Wrapper} & {
    ${({ theme }) => `${theme.breakpoints.xxl} {
      display: contents;
    }`}
  }
`;